import { getParameterByName } from '@hotjar/webapp/features/Playbacks/store/utils';
import { subscribeAndSendCurrentTimeToHeatmaps } from './subscribeAndSendCurrentTimeToHeatmaps';
import type { Store } from '../../../store/player/types';
import { CONTROLS_AND_ELEMENTS_SELECTORS } from '../../../constants/heatmaps-retaker';
import { jumpTo } from './jumpTo';
import type { EventMarker } from '@hotjar/webapp/features/Playbacks/types';

const CUSTOM_CSS = `
${CONTROLS_AND_ELEMENTS_SELECTORS.TOP_BAR},
${CONTROLS_AND_ELEMENTS_SELECTORS.SELECTION_TOOLTIP},
${CONTROLS_AND_ELEMENTS_SELECTORS.COMMENTS_CONTAINER},
${CONTROLS_AND_ELEMENTS_SELECTORS.RELEVANT_ACTIONS_CONTAINER},
${CONTROLS_AND_ELEMENTS_SELECTORS.RECORDING_CONTROLS_CONTAINER},
${CONTROLS_AND_ELEMENTS_SELECTORS.HIGHLIGHTS_REACTIONS_CONTAINER},
${CONTROLS_AND_ELEMENTS_SELECTORS.PLAYER_CONTROLS_CONTAINER}
  > *:not(${CONTROLS_AND_ELEMENTS_SELECTORS.PLAYER_TIME_INFO}):not(${CONTROLS_AND_ELEMENTS_SELECTORS.PLAY_PAUSE_BUTTON})
{
  display: none !important;
}

${CONTROLS_AND_ELEMENTS_SELECTORS.ADDRESS_BAR} { display: none !important; }
`;

const generateSnapshotEvent = (time: number, duration: number): EventMarker => ({
  key: '1',
  time,
  duration,
  url: '',
  progress_pos: ((time / duration) * 100).toFixed(2), // Needed in string format '12.34'
  type: 'heatmap_screenshot',
  is_highlighted: false,
});

/**
 * Set Retaker Mode Settings
 */
export const setRetakerSettings = (store: Store): void => {
  const state = store.getState();
  const queryParamTime = Number(getParameterByName('startTime') || 0);

  const style = document.createElement('style');
  // The following CSS is not a user generated style.
  // However, it contains dynamic data, and because of that, it is ignored.
  // nosemgrep
  style.innerHTML = CUSTOM_CSS;
  document.body.appendChild(style);

  state.setSkipNonMutationEvents(true);

  // Retaker mode wants player in paused state so that user can see the place where screenshot was taken
  state.setAutoplay(false);

  // Jump to specified time in the url param `startTime`
  state.setJumpToPause(true);

  // Mute the click sound
  state.setIsMuteClicksActive(true);

  // Hide the side panel
  state.setShowSidePanel(false);

  subscribeAndSendCurrentTimeToHeatmaps();

  // Jump to specified time in the url param `startTime`
  // after the event `recording-loaded` has been triggered in `./startRecording.ts`
  window.addEventListener('recording-loaded', () => {
    const newState = store.getState();
    const event = generateSnapshotEvent(queryParamTime, newState.recording?.duration ?? 0);
    jumpTo(store, queryParamTime);

    newState.setShared(false);
    newState.setWorthWatching(false);
    newState.setEvents([event], [event], [event]);

    window.parent.postMessage(
      {
        event: 'hm_retaker_event',
        payload: { isLoaded: true },
      },
      window.location.origin,
    );
  });
};
